import { Button } from "components";
import Breadcrumb from "components/Breadcrumb/Breadcrumb";
import Tabs from "components/TabNavBar/Tab";
import OperationDocumentList from "pages/OperationDocument/OperationDocumentList";
import WorkStationOperationList from "pages/WorkStationOperation.jsx/WorkStationOperationList";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const tabItems = [
  { label: "Workstations", value: "Workstations" },
  { label: "Documents", value: "Operation Documents" },
];
function OperationTab() {
  const [download, setDownload] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState();
  const { id } = useParams();
  const childRef = React.useRef(null);

  const [erplist, setErplist] = useState([]);

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const name = sessionStorage.getItem("name");
  const tab = sessionStorage.getItem("tab");

  useEffect(() => {
    setActiveTab(
      sessionStorage.getItem("tab") === "Workstations"
        ? "Workstations"
        : sessionStorage.getItem("tab")
    );
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem("tab", tab);
  };
  const onhandler = () => {
    if (activeTab === "Workstations") {
      navigate("/operation/workstation/add", { state: { id: id, name: name } });
    }
    if (activeTab === "Operation Documents") {
      navigate(`/operationdocument/add/${id}`, {
        state: { id: id, name: name },
      });
    }
  };

  function downloadExcel() {
    childRef.current.downloadExcel();
  }
  function downloadPdf() {
    childRef.current.downloadPdf();
  }

  return (
    <>
      {erplist.some((item) => item.erp_module_id == 4 && item.view) ? (
        <div className="w-full flex flex-col">
          <div className="flex flex-row w-full items-center  mt-2  rounded-md ">
            {/* <nav className="flex w-full p-1" aria-label="Breadcrumb">
              <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                <li className="inline-flex items-center">
                  <span
                    onClick={() => navigate("/operationlist")}
                    className="inline-flex font-inter items-center underline text-sm font-medium text-purple-500 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white"
                  >
                    Opeartion
                  </span>
                </li>
                <li className="flex items-center">
                  <svg
                    className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 6 10"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 9 4-4-4-4"
                    />
                  </svg>
                  <span
                    className="ms-1 text-sm font-medium font-inter text-gray-700 hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white"
                    style={{ minWidth: 0, flexShrink: 1 }}
                  >
                    {name}
                  </span>
                </li>
                <li aria-current="page" className="flex items-center">
                  <svg
                    className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 6 10"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 9 4-4-4-4"
                    />
                  </svg>
                  <span
                    className="ms-1 text-sm font-medium font-inter text-gray-700 md:ms-2 dark:text-gray-400"
                    style={{ minWidth: 0, flexShrink: 1 }}
                  >
                    {tab}
                  </span>
                </li>
              </ol>
            </nav> */}
            <Breadcrumb
              items={[
                { label: "Operation", path: "/operationlist" },
                { label: name },
                { label: activeTab },
              ]}
            />
            <div className="flex text-3xl gap-2 flex-row justify-end items-center font-inter px-[10px] w-full leading-none tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white ml-20">
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[110px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    class="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <span
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={downloadPdf}
                      >
                        PDF
                      </span>
                    </li>
                    <li>
                      <span
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={downloadExcel}
                      >
                        Excel
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex flex-col items-center justify-center">
                {erplist.some(
                  (item) => item.erp_module_id === 4 && item.add
                ) && (
                  <button
                    type="button"
                    id="dropdownDefaultButton"
                    className="text-white-A700 bg-blue-700  hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 "
                    onClick={() => onhandler()}
                  >
                    + Add
                  </button>
                )}
              </div>
            </div>
          </div>
          {/* <div className="w-full p-2">
            <nav className=" border-2 shadow-md bg-blue-100 rounded-lg">
              <div className="container mx-auto">
                <ul className="flex">
                  <li
                    className={`mr-6 ml-6 p-2 w-30 text-sm ${
                      activeTab === "Workstations"
                        ? "bg-gray-150 text-blue-500 shadow-md border-b-2 border-blue-500"
                        : ""
                    }`}
                  >
                    <Button
                      className="text-white"
                      onClick={() => {
                        handleTabClick("Workstations");
                      }}
                    >
                      Workstations
                    </Button>
                  </li>
                  <li
                    className={`mr-6 p-2 w-30 text-sm ${
                      activeTab === "Operation Documents"
                        ? "bg-gray-150 text-blue-500 shadow-md border-b-2 border-blue-500"
                        : ""
                    }`}
                  >
                    <Button
                      className="text-white"
                      onClick={() => {
                        handleTabClick("Operation Documents");
                      }}
                    >
                      Documents
                    </Button>
                  </li>
                </ul>
              </div>
            </nav>
          </div> */}
          <Tabs
            tabs={tabItems}
            activeTab={activeTab}
            onTabChange={handleTabClick}
          />
          <div>
            {activeTab === "Operation Documents" && (
              <OperationDocumentList id={id} item_name={name} ref={childRef} />
            )}
            {activeTab === "Workstations" && (
              <WorkStationOperationList
                id={id}
                item_name={name}
                ref={childRef}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default OperationTab;
